// Funciones
import { ROUTES } from "../../../../../const/routes";

/**
 * Assts de la palanca del tragamonedas
 * @param {*} scene 
 */
export function cargaAssetsPalanca(scene) {
  scene.load.image(
    "palanca1Estatica",
    ROUTES.rutaTragamonedasPalanca + "/palanca1EstaticaResized.png"
  );

  scene.load.spritesheet(
    "palanca1Movimiento",
    ROUTES.rutaTragamonedasPalanca + "/palanca1MovimientoResized-Sheet.png",
    {
      frameWidth: 78,
      frameHeight: 177,
    }
  );
}
